<template>
    <div class="row p-2">
        <div>
            <h1>{{ $t("products.newCalculation") }}</h1>
        </div>
        <div class="mt-4">
            <form @submit.prevent="submitCreation">
                <div class="row w-50">
                    <div class="col-12 colg-6 box d-flex flex-column">
                        <label for="inputSelect" class="form-label">{{ $t("products.enterInput") }}</label>
                        <select v-model="postData.selectedInput" class="form-control form-select" id="inputSelect"
                            name="inputSelect" size="1">
                            <option v-for="product in products" :key="product.id" :value="product.id">
                                {{ product.name }} ( {{ product.shorten_name }} )
                            </option>
                        </select>
                    </div>
                    <div class="col-12 colg-6 box d-flex flex-column mt-3">
                        <label for="outputSelect" class="form-label">{{ $t("products.enterOutput") }}</label>
                        <select v-model="postData.selectedOutput" class="form-control form-select" id="outputSelect"
                            name="outputSelect" size="1">
                            <option v-for="product in products" :key="product.id" :value="product.id">
                                {{ product.name }} ( {{ product.shorten_name }} )
                            </option>
                        </select>
                    </div>
                    <div class="col-12 colg-6 box d-flex flex-column mt-3">
                        <label for="coeficientInput" class="form-label">{{ $t("products.enterCoeficient") }}</label>
                        <input v-model.number="postData.coeficient" type="number" name="coeficient" class="form-control"
                            id="coeficientInput" />
                    </div>
                    <div class="col-12 mt-4">
                        <button type="submit" class="btn btn-primary text-white px-5 fw-bold">
                            {{ $t("utils.add") }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            products: [],
            postData: {
                selectedInput: null,
                selectedOutput: null,
                coeficient: 1
            },
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get("/unhidden_products").then((response) => {
                this.products = response.data.items
            })
        },
        submitCreation() {
            this.$store.getters.api.post("/product_conversions/add", this.postData
            ).then((response) => {
                this.$router.push({ name: 'ProductConversions' });
            }).catch((error) => {
                if (error.response.data.error === "Conversion option for this output product already exists") {
                    alert(this.$t("products.covnersionExist"));
                }
            });
        },
    }
}
</script>
<style lang="">

</style>